import { ParametroService } from '../services/parametro.service';
import { Router } from '@angular/router';
var ParametrosComponent = /** @class */ (function () {
    function ParametrosComponent(parametroService, router) {
        this.parametroService = parametroService;
        this.router = router;
        this.isLoading = true;
        this.display = false;
        this.parametros = [];
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.errores = new Array();
    }
    ParametrosComponent.prototype.ngOnInit = function () {
        this.obtenerParametros();
    };
    ParametrosComponent.prototype.onSubmit = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.parametroService.actualizar(this.parametros)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizar parametros";
            if (result.status == 204) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "Los datos se han actualizado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Actualizar parametros";
            _this.alert.mensaje = "Los datos se han actualizado correctamente";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    ParametrosComponent.prototype.obtenerParametros = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.parametroService.listado().subscribe(function (result) {
            _this.spinner.isRunning = false;
            _this.parametros = result;
        });
    };
    ParametrosComponent.prototype.getInputType = function (parametro) {
        var tipo = "text";
        switch (parametro.tipoDato) {
            case 0:
                tipo = "text";
                break;
            case 1:
            case 2:
                tipo = "number";
                break;
            case 5:
                tipo = "password";
                break;
        }
        return tipo;
    };
    ParametrosComponent.prototype.volver = function () {
        this.router.navigate(['dashboard/clientes']);
    };
    ParametrosComponent.ctorParameters = function () { return [{ type: ParametroService }, { type: Router }]; };
    return ParametrosComponent;
}());
export { ParametrosComponent };
//# sourceMappingURL=parametros.component.js.map


// WEBPACK FOOTER //
// parametros.component.js